// TSS vite/03 — cache keys for the coordination demo.
//
// `source` is part of every key: the same screen answers from a fixture or
// from a Core, and one cached under the other would be a lie that survives the
// switch.

export const coordinationKeys = {
    all: ['coordination'],
    fleet: (source) => ['coordination', source, 'fleet'],
    reviewWork: (source) => ['coordination', source, 'review-work'],
    catalog: (kind) => ['coordination', 'catalog', kind],
    attention: (source, params) => ['coordination', source, 'attention', params],
    seats: (source, params) => ['coordination', source, 'seats', params],
    seat: (source, id) => ['coordination', source, 'seat', String(id)],
    control: (source, id) => ['coordination', source, 'control', String(id)],
    history: (source, params) => ['coordination', source, 'history', params],
    snapshot: (source) => ['coordination', source, 'snapshot'],
    taskMetrics: (source, id) => ['coordination', source, 'metrics', 'task', String(id)],
    durations: (source, params) => ['coordination', source, 'metrics', 'durations', params],
};
